export const applicantEligibilityStatus = {
  waitingForApproval: 0,
  approvedByRA: 100000000,
  declinedByRA: 100000001,
  notEligible: 100000002,
  ChangeDecision: 100000003,
};

export const programTypes = {
  youngProgram: 0,
  regularProgram: 1,
  CollaborativeTrack: 3,
  SoloTrack: 4,
};

export const proposalEligibilityStatus = {
  empty: 0,
  approvedByRA: 100000000,
  approvedByGIF: 100000001,
  notEligible: 100000002,
  submittedByApplicationLeader: 100000003,
  unlockedByRA: 100000004,
  submittedByResearchers: 100000005,
};

export const grantStatus = {
  preGrant: 100000000,
  grant: 100000001,
  completedArchived: 100000002,
  frozen: 100000003,
  grantExtension: 100000004,
  canceled: 100000005,
  returnToRA: 100000006,
  approvedByRA: 100000007,
  approvedByGIF: 100000008,
  completed: 100000009,
  delayedStart: 100000010,
};

export const PRE_PROPOSAL_STATUS = 957290000;



